export default "__VITE_ASSET__OKqA1bn5__"